export const TARGET_DATA_FRAMES_PER_SEGMENT = 100;
export const MAX_DATA_SEGMENTS = 8;
export const MAX_SEGMENTABLE_DATA_FRAMES = 1_200;

export interface DataSegmentRange {
  readonly index: number;
  readonly startDataIndex: number;
  readonly endDataIndexExclusive: number;
  readonly total: number;
}

export function createDataSegmentRanges(
  dataFrameCount: number,
): readonly DataSegmentRange[] {
  if (
    !Number.isSafeInteger(dataFrameCount) ||
    dataFrameCount <= 0 ||
    dataFrameCount > MAX_SEGMENTABLE_DATA_FRAMES
  ) {
    throw new Error(
      `Data frame count must be between 1 and ${MAX_SEGMENTABLE_DATA_FRAMES.toString()}.`,
    );
  }

  const segmentCount = Math.min(
    MAX_DATA_SEGMENTS,
    Math.max(1, Math.ceil(dataFrameCount / TARGET_DATA_FRAMES_PER_SEGMENT)),
  );
  const baseSize = Math.floor(dataFrameCount / segmentCount);
  const extraFrameCount = dataFrameCount % segmentCount;
  const segments: DataSegmentRange[] = [];
  let startDataIndex = 0;

  for (let index = 0; index < segmentCount; index += 1) {
    const total = baseSize + (index < extraFrameCount ? 1 : 0);
    const endDataIndexExclusive = startDataIndex + total;
    segments.push(
      Object.freeze({
        index,
        startDataIndex,
        endDataIndexExclusive,
        total,
      }),
    );
    startDataIndex = endDataIndexExclusive;
  }

  return Object.freeze(segments);
}
